import React, {useContext} from 'react';
import {Controller, useFormContext, useWatch} from 'react-hook-form';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {FormFieldConfigSize} from '@src/@types/components/Form';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import classnames from '@src/helpers/classnames';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import Switch from '@src/components/Fields/Switch';
import {IChecklistModel} from '@src/@interfaces/models/Checklist/IChecklistModel';
import {IChecklistItemModel} from '@src/@interfaces/models/Checklist/IChecklistItemModel';

export function IsOrderCompletelyPayedItemField({rowIndex: index, config: {label}}: IListColumnProps) {
    const {
        control,
        fieldName,
        forceDisabled,
        forceReadonly,
    } = useContext<IFormFieldItemPropsContext<IChecklistModel> | null>(FormFieldItemPropsContext) ?? {};
    const [design] = useContext(FormFieldDesignContext);

    const name = `${fieldName}.${index}.is_order_completely_payed_item`;

    const {setValue} = useFormContext();
    const items: Pick<IChecklistItemModel, 'id' | 'title' | 'is_order_completely_payed_item'>[] = useWatch({
        control,
        name: fieldName as string
    });

    return <>
        <Controller
                control={control}
                name={name}
                render={({field: {name, value, onChange, onBlur}, fieldState: {error}}) => {
                    return <Switch
                            id={name}
                            label={label}
                            className={classnames({
                                'is-invalid': Boolean(error)
                            })}
                            name={name}
                            bsSize={FormFieldConfigSize.SM}
                            readOnly={design.fieldsAreReadOnly || forceReadonly}
                            disabled={design.fieldsAreDisabled || forceDisabled}
                            checked={value === true}
                            onChange={event => {
                                if (event.target.checked) {
                                    items.forEach((item, i) => {
                                        if (item.is_order_completely_payed_item && i !== index) {
                                            setValue(`${fieldName}.${i}.is_order_completely_payed_item`, false);
                                        }
                                    });
                                }

                                onChange(event);
                            }}
                            onBlur={onBlur}
                    />;
                }}
        />

        <FormErrorMessage fieldName={name}/>
    </>;
}
